// Library imports
import styled from 'styled-components';
import { MDBCol } from 'mdb-react-ui-kit';

export const CompareListCol = styled(MDBCol)`
    display: flex;
    flex-direction: column;
`;
